module.exports = __webpack_public_path__ + "img/home--how--find-a-tutor.043a459b.svg";